import { watchDeleteRecord } from './redux/sagas/watchDeleteRecord';
import { watchGetGeneralInfomationOfRecords } from './redux/sagas/watchGetGeneralInfomationOfRecords';
import { watchGetMetaDataOfRecord } from './redux/sagas/watchGetMetaDataOfRecord';
import { watchUpgradeSection } from './redux/sagas/watchUpgradeSection';

export { ListingSectionsUpdatable as default } from './ListingSectionsUpdatable';

export const sagasListingSectionsUpdatable = [watchGetGeneralInfomationOfRecords, watchGetMetaDataOfRecord, watchUpgradeSection, watchDeleteRecord];
